export default __webpack_public_path__ + "static/media/M02.a0d40ceb.svg";